// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import React, { FunctionComponent, ReactElement, useState } from "react";
import { useAuthContext } from "@asgardeo/auth-react";
import { DefaultLayout } from "../../layouts/DefaultLayout";

/**
 * Page to display Authentication Failure Page.
 *
 * @param {AuthenticationFailureInterface} props - Props injected to the component.
 *
 * @return {React.ReactElement}
 */
export const AuthenticationFailure: FunctionComponent = (): ReactElement => {

  const { signIn } = useAuthContext();
  const [ hasAuthenticationErrors, setHasAuthenticationErrors ] = useState<boolean>(false);
  
  const handleLogin = () => {
    signIn()
        .catch(() => setHasAuthenticationErrors(true));
  };

  return (
    <DefaultLayout hasErrors={ hasAuthenticationErrors }>
      <div className="content">
          <div className="ui visible negative message">
              <div className="header"><b>Authentication Error!</b></div>
              <p>Please check the application configuration and try login again!.</p>
          </div>
          <button className="btn primary" style={{backgroundColor:"orange"}}
              onClick={ handleLogin }>Login</button>
      </div>
    </DefaultLayout>
  );
};
